document.addEventListener('DOMContentLoaded', function () {
  var PIN_NATIVE_SIZE = 24;
  var PIN_SCALE = 2.76;
  var PIN_SCALE_ACTIVE = PIN_SCALE * 1.5;
  var XLINK_NS = 'http://www.w3.org/1999/xlink';

  function setPinTransform(pin, scale) {
    var x = parseFloat(pin.dataset.x);
    var y = parseFloat(pin.dataset.y);
    if (isNaN(x) || isNaN(y)) return;
    // Translate so the pin's own tip (12, 24 in its native 24x24 artwork) lands exactly on
    // (x, y) regardless of scale, then scale about that same tip.
    var tx = x - (PIN_NATIVE_SIZE / 2) * scale;
    var ty = y - PIN_NATIVE_SIZE * scale;
    pin.setAttribute('transform', 'translate(' + tx.toFixed(2) + ' ' + ty.toFixed(2) + ') scale(' + scale + ')');
  }

  document.querySelectorAll('[data-islay-map]').forEach(function (svg) {
    var initialized = false;
    var details = svg.closest('details');
    var scope = details || svg.closest('.islay-map-section') || document;

    // getBBox()/layout only resolve correctly once the SVG is actually visible - and this map
    // starts out inside a closed <details>, which the browser hides via display: none until
    // opened. So positioning/wiring is deferred until the details element first opens, rather
    // than running at page load.
    function initMap() {
      if (initialized) return;
      initialized = true;

      // The background image is a large, richly painted map (not a simple line trace), so it's
      // only fetched once the map is actually opened rather than unconditionally at page load -
      // this same initMap() only runs on first open (see the toggle listener below).
      var bgImage = svg.querySelector('[data-islay-map-image]');
      if (bgImage && svg.dataset.imageSrc) {
        bgImage.setAttributeNS(XLINK_NS, 'href', svg.dataset.imageSrc);
        bgImage.setAttribute('href', svg.dataset.imageSrc);
      }

      var pins = svg.querySelectorAll('[data-islay-pin]');
      var detailPanels = scope.querySelectorAll('[data-islay-distillery-panel]');
      var legendPills = scope.querySelectorAll('[data-islay-distillery-legend-pill]');
      var stage = scope.querySelector('.islay-region-info__stage');
      var defaultContent = scope.querySelector('[data-islay-region-default]');

      // .islay-region-info__stage stacks the default content and every distillery panel in the
      // same grid cell (grid-area: 1 / 1) so the slide-in transform has somewhere to live without
      // needing an explicit height - but that also means its implicit height is the TALLEST of
      // everything stacked there, default content and all 10 panels combined, not just whichever
      // one is actually visible right now. Setting an explicit height here, matched to only the
      // currently-visible content, is what keeps the card's own height honest instead of always
      // reserving room for the single tallest panel across every distillery.
      function syncStageHeight() {
        if (!stage) return;
        var activePanel = null;
        detailPanels.forEach(function (d) {
          if (d.classList.contains('is-active')) activePanel = d;
        });
        var visible = activePanel || defaultContent;
        if (!visible) return;
        stage.style.height = visible.scrollHeight + 'px';
      }

      syncStageHeight();

      // Staggers the initial drop-in so pins settle onto the map one at a time, top of the map
      // first down to the bottom, instead of all animating at once or in distillery-list order.
      // The delay is cleared again once every pin has finished (see the setTimeout below) so
      // later clicks (grow/shrink on activate) respond immediately rather than inheriting this
      // one-time stagger.
      var DROP_IN_STAGGER_MS = 90;
      var pinsByHeight = Array.prototype.slice.call(pins).sort(function (a, b) {
        return parseFloat(a.dataset.y) - parseFloat(b.dataset.y);
      });
      pinsByHeight.forEach(function (pin, index) {
        pin.style.transitionDelay = index * DROP_IN_STAGGER_MS + 'ms';
        setPinTransform(pin, PIN_SCALE);
      });
      setTimeout(function () {
        pins.forEach(function (pin) {
          pin.style.transitionDelay = '';
        });
      }, pins.length * DROP_IN_STAGGER_MS + 700);

      function findDetail(name) {
        var needle = name.trim().toLowerCase();
        var match = null;
        detailPanels.forEach(function (d) {
          if ((d.dataset.distilleryName || '').toLowerCase() === needle) match = d;
        });
        return match;
      }

      function isOpen(name) {
        var detail = findDetail(name);
        return !!(detail && detail.classList.contains('is-active'));
      }

      function setOpenState(name, open) {
        var needle = name.trim().toLowerCase();
        pins.forEach(function (p) {
          var isMatch = (p.dataset.distilleryName || '').toLowerCase() === needle;
          if (isMatch) {
            p.classList.toggle('is-active', open);
            setPinTransform(p, open ? PIN_SCALE_ACTIVE : PIN_SCALE);
            if (open) {
              // Re-append so the grown pin paints on top of its neighbors instead of getting
              // clipped behind them - SVG has no z-index, paint order follows DOM order.
              p.parentNode.appendChild(p);
            }
          } else if (open) {
            p.classList.remove('is-active');
            setPinTransform(p, PIN_SCALE);
          }
        });
        detailPanels.forEach(function (d) {
          var isMatch = (d.dataset.distilleryName || '').toLowerCase() === needle;
          if (isMatch) {
            d.classList.toggle('is-active', open);
          } else if (open) {
            d.classList.remove('is-active');
          }
        });
        legendPills.forEach(function (pill) {
          var isMatch = (pill.dataset.distilleryName || '').toLowerCase() === needle;
          if (isMatch) {
            pill.classList.toggle('is-active', open);
          } else if (open) {
            pill.classList.remove('is-active');
          }
        });
        syncStageHeight();
      }

      // Single distillery shown at a time: clicking a closed pin/legend pill shows its detail
      // panel (and hides any other); clicking the one already shown hides it again.
      function toggleDistillery(name) {
        var open = isOpen(name);
        setOpenState(name, !open);
      }

      // Applies the real product-grid filter for a distillery (checking its checkbox in whatever
      // filter form is present) and scrolls down to the grid, rather than navigating away - used
      // by each panel's "View all X bottles" link. Returns whether a matching, enabled checkbox
      // was actually found, so the caller can fall back to the link's own href (e.g. a linked
      // collection or search URL) when this page has no such filter option available.
      function activateDistillery(name) {
        var needle = name.trim().toLowerCase();
        var matchedAny = false;

        // Both the desktop and mobile filter forms render their own copy of the distillery
        // checkbox list (see snippets/whisky-filter-item.liquid) - update whichever are present
        // so the filter state stays in sync regardless of viewport/open drawer.
        document.querySelectorAll('[data-distillery-controls]').forEach(function (controls) {
          var items = controls.querySelectorAll('.whisky-filter__item');
          var targetCheckbox = null;

          items.forEach(function (item) {
            var searchText = (item.dataset.filterSearchText || '').toLowerCase();
            var checkbox = item.querySelector('input[type="checkbox"]');
            if (!checkbox) return;
            if (searchText === needle || searchText.indexOf(needle) !== -1 || needle.indexOf(searchText) !== -1) {
              if (!checkbox.disabled) targetCheckbox = checkbox;
            }
          });

          if (!targetCheckbox) return;
          matchedAny = true;

          // Single-select: viewing one distillery's whisky shows just that, not an accumulating
          // list of every distillery ever viewed.
          items.forEach(function (item) {
            var checkbox = item.querySelector('input[type="checkbox"]');
            if (checkbox && checkbox !== targetCheckbox && checkbox.checked) {
              checkbox.checked = false;
            }
          });

          if (!targetCheckbox.checked) {
            targetCheckbox.checked = true;
          }
          // facets.js listens for 'input' bubbling up the filter <form> to trigger its debounced
          // AJAX refetch - dispatching it here reuses that exact same flow rather than
          // reimplementing filtering.
          targetCheckbox.dispatchEvent(new Event('input', { bubbles: true }));
          targetCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        });

        if (matchedAny) {
          var grid = document.getElementById('ProductGridContainer');
          if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        return matchedAny;
      }

      function clearDistilleryFilter() {
        // Both the desktop and mobile filter forms render their own copy of the distillery
        // checkbox list - uncheck whichever are present so the filter state stays in sync
        // regardless of viewport/open drawer.
        document.querySelectorAll('[data-distillery-controls]').forEach(function (controls) {
          controls.querySelectorAll('.whisky-filter__item').forEach(function (item) {
            var checkbox = item.querySelector('input[type="checkbox"]');
            if (checkbox && checkbox.checked) {
              checkbox.checked = false;
              checkbox.dispatchEvent(new Event('input', { bubbles: true }));
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        var activeDetail = null;
        detailPanels.forEach(function (d) {
          if (d.classList.contains('is-active')) activeDetail = d;
        });
        if (activeDetail) {
          setOpenState(activeDetail.dataset.distilleryName || '', false);
        }

        var grid = document.getElementById('ProductGridContainer');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      var viewAllLink = scope.querySelector('[data-islay-view-all]');
      if (viewAllLink) {
        viewAllLink.addEventListener('click', function (event) {
          event.preventDefault();
          clearDistilleryFilter();
        });
      }

      function wireToggle(el, name) {
        el.addEventListener('click', function () {
          toggleDistillery(name);
        });

        el.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggleDistillery(name);
          }
        });
      }

      pins.forEach(function (pin) {
        wireToggle(pin, pin.dataset.distilleryName || '');
      });

      legendPills.forEach(function (pill) {
        wireToggle(pill, pill.dataset.distilleryName || '');
      });

      detailPanels.forEach(function (panel) {
        var name = panel.dataset.distilleryName || '';
        var backButton = panel.querySelector('[data-islay-panel-back]');
        if (backButton) {
          backButton.addEventListener('click', function () {
            setOpenState(name, false);
          });
        }

        var viewAllLink = panel.querySelector('[data-islay-view-whiskies]');
        if (viewAllLink) {
          viewAllLink.addEventListener('click', function (event) {
            // Filters this same page's product grid and scrolls to it when a matching filter
            // option actually exists here; otherwise falls through to the link's own href (its
            // linked collection, or a search fallback - see sections/islay-distillery-map.liquid).
            if (activateDistillery(viewAllLink.dataset.distilleryName || name)) {
              event.preventDefault();
            }
          });
        }
      });

      // Text reflow at a different viewport width can change how many lines the visible content
      // wraps to, so its scrollHeight (and therefore the height synced above) can change too -
      // debounced since resize fires continuously while dragging.
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(syncStageHeight, 150);
      });
    }

    if (details) {
      if (details.open) initMap();
      details.addEventListener('toggle', function () {
        if (details.open) initMap();
      });
    } else {
      initMap();
    }
  });
});
